import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { Constants } from '../../constants/constants';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';



@Component({
  selector: 'modal-asset',
  templateUrl: './modal-new-asset.component.html',
  styleUrls: ['./modal-new-asset.component.scss'],
})
export class ModalNewAssetComponent implements OnInit {


  fields: any = [];

  assetName: string = "";
  assetDescription: string = "";
  fieldName: string = "";
  fieldBinding: string = "";
  fieldKeyboard: string = "text";
  assetGroup: string = "";
  requireConditionReport: boolean = false;
  isStreetLight: boolean = false;

  assetGroupError: boolean = false;
  assetNameError: boolean = false;
  fieldNameError: boolean = false;
  bindingNameError: boolean = false;
  fieldError: boolean = false;

  mapIcon: string = "default";


  constructor(private router: Router, public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController,
   public assetService: AssetService, public clientService: ClientService) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {

  }


  ionViewWillLeave()
  {

  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'CreateAssetModal');
  }


  toggleIsStreetLight(choice)
  {
    this.isStreetLight = choice;

    if (this.isStreetLight)
    {
      var newField = { KeyboardType: "number", Name: "Circuit ID", Binding: "{{UNITNUM}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "No of points connected", Binding: "{{UNITNUM}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "text", Name: "Earthing arrangements TNC-S / TNS / TT", Binding: "{{EARTHING}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "text", Name: "Earthing Distributor (D) / Earth Electrode (E)", Binding: "{{EARTHDIST}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "Nom Voltage (by enquiry)", Binding: "{{NOMVOLT}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "text", Name: "PSCC Ipf (D. or M.) (ka)", Binding: "{{PSCC}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "Earthing cond. Csa (mm2)", Binding: "{{CSA}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "text", Name: "Prot Bond Cond csa (mm2)", Binding: "{{PROTBOND}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "text", Name: "Cable Type / Installation", Binding: "{{CABTYPE}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "Circuit Conductor Csa Line (mm2)", Binding: "{{LINEMM2}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "Circuit Conductor Csa CPC (mm2)", Binding: "{{CPCMM2}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "text", Name: "Overcurrent Protective Device BS EN and Type", Binding: "{{BSEN}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "Overcurrent Protective Device Rating (A)", Binding: "{{RATEA}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "Overcurrent Protective Device RCD Rated IA (mA)", Binding: "{{RATEIA}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "Max Device Zs from BS7671", Binding: "{{MAXDEV}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "ELI Ze (Ω)", Binding: "{{ELID}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "text", Name: "ELI Ze (D/M)", Binding: "{{ELIDM}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "Continuity (or R1 + R2) OK", Binding: "{{CONTI}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "text", Name: "Installation Resistance Line / Neutral (Mo)", Binding: "{{NEUTR}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "text", Name: "Installation Resistance Line / Earth (Mo)", Binding: "{{EARTH}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "text", Name: "Installation Resistance Neutral / Earth (Mo)", Binding: "{{NEUTREARTH1}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "text", Name: "Installation Resistance Line+Neutral / Earth (Mo)", Binding: "{{NEUTREARTH2}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "text", Name: "Polarity", Binding: "{{POLAR}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "Source Voltage (measured)", Binding: "{{SRCVOLT}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "On load voltage (at end measure)", Binding: "{{LOADVOLT}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "E.L.I. Zs (Ω)", Binding: "{{ELIZS}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "RCD At IAn (ms)", Binding: "{{ATIAN}}" };
      this.fields.push(newField);

      var newField = { KeyboardType: "number", Name: "RCD At 5xIAn (ms)", Binding: "{{AT5XIAN}}" };
      this.fields.push(newField);
    }
    else
    {
      this.fields = [];
    }
  }


  createNewAssetType()
  {
    var errorFound = false;
    this.assetNameError = this.fieldError = this.assetGroupError = false;

    if (this.assetName == "")
    {
      this.assetNameError = true;
      errorFound = true;
    }

    if (this.fields.length == 0)
    {
      this.fieldError = true;
      errorFound = true;
    }

    if (this.assetGroup == "")
    {
      this.assetGroupError = true;
      errorFound = true;
    }

    if (errorFound)
    {
      return;
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      var data = {
        ClientUid: this.clientService.getClientUid(),
        OrganisationUid: this.clientService.getOrganisationUid(),
        Name: this.assetName,
        Fields: this.fields,
        Description: this.assetDescription,
        AssetGroupUid: this.assetGroup,
        MapIcon: this.mapIcon,
        requireConditionReport: this.requireConditionReport,
        isStreetLight: this.isStreetLight
      }

      this.assetService.createNewAssetType(data).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var returnData = { assetAdded: true };
          this.closeModal(returnData);
          this.appearanceService.presentToast("Asset added.", Constants.TOAST_SUCCESS);
        }
        else
        {
            this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  addField()
  {
    var errorFound = false;
    this.fieldNameError = this.bindingNameError = false;

    if (this.fieldName == "")
    {
      this.fieldNameError = true;
      errorFound = true;
    }

    if (this.fieldBinding == "")
    {
      this.bindingNameError = true;
      errorFound = true;
    }

    if (errorFound)
    {
      return;
    }

    var newField = { KeyboardType: this.fieldKeyboard, Name: this.fieldName, Binding: "{{" + this.fieldBinding.toUpperCase() + "}}" };
    this.fields.push(newField);

    this.fieldName = "";
    this.fieldBinding = "";
  }


  selectMapIcon(choice)
  {
    this.mapIcon = choice;
  }

  
}
